module.exports = __webpack_public_path__ + "img/ic_upload_select.8a63f1d7.svg";